<style lang="stylus">
    .ft-ss-morebox
        floatTool_dropbox()
        padding 10px 16px
        width max-content;
        .layout_p_input
            padding 10px 0
            display flex
            justify-content space-between
            align-items center
            .ivu-checkbox
                vertical-align bottom
                margin-right 4px
                &:not(.ivu-checkbox-checked)
                    .ivu-checkbox-inner
                        background-color var(--bg-color-tertiary)
</style>

<template>
    <div class="ft-ss-morebox" @click.stop @mousedown.stop>
        <div class="layout_p_input" v-if="layoutOptions.hasOwnProperty('FlipX')">
            <Checkbox v-model="isFlipX" @on-change="setOption('FlipX')">{{ $t("hFlip") }}</Checkbox>
            <i-select
                v-model="layoutData.layoutOptions.FlipX"
                style="width: 80px"
                size="small"
                placement="bottom-end"
                @on-change="setOption('FlipX')"
                :disabled="!isFlipX"
            >
                <i-option :value="1">{{ $t("odd") }}</i-option>
                <i-option :value="2">{{ $t("even") }}</i-option>
                <i-option :value="3">{{ $t("all") }}</i-option>
            </i-select>
        </div>
        <div class="layout_p_input" v-if="layoutOptions.hasOwnProperty('FlipY')">
            <Checkbox v-model="isFlipY" @on-change="setOption('FlipY')">{{ $t("vFlip") }}</Checkbox>
            <i-select
                v-model="layoutData.layoutOptions.FlipY"
                style="width: 80px"
                size="small"
                placement="bottom-end"
                @on-change="setOption('FlipY')"
                :disabled="!isFlipY"
            >
                <i-option :value="1">{{ $t("odd") }}</i-option>
                <i-option :value="2">{{ $t("even") }}</i-option>
                <i-option :value="3">{{ $t("all") }}</i-option>
            </i-select>
        </div>
        <div class="layout_p_input" v-if="layoutOptions.hasOwnProperty('InvertShape')">
            <Checkbox v-model="layoutData.layoutOptions.InvertShape" @on-change="setOption('InvertShape')" :disabled="hideInvertShape">
                {{ $t("imgReverse") }}
            </Checkbox>
        </div>
        <div class="layout_p_input" v-if="layoutOptions.hasOwnProperty('SwapDirection')">
            <Checkbox v-model="layoutData.layoutOptions.SwapDirection" @on-change="setOption('SwapDirection')">{{ $t("swapDir") }}</Checkbox>
        </div>
    </div>
</template>

<script lang="ts">
    declare var eLayoutType: any;
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class SmartShapeMore extends Vue {
        get layoutOptions() {
            return this.layoutData.layoutOptions || {};
        }
        get isFlipX() {
            return !!this.layoutData.layoutOptions?.FlipX;
        }
        set isFlipX(v: any) {
            this.layoutData.layoutOptions.FlipX = v * 3;
        }
        get isFlipY() {
            return !!this.layoutData.layoutOptions?.FlipY;
        }
        set isFlipY(v: any) {
            this.layoutData.layoutOptions.FlipY = v * 3;
        }
        get layoutData() {
            return this.$store.state.ui.layoutData;
        }
        set layoutData(v) {
            this.$store.commit("setStatus", {
                type: "layoutData",
                data: v,
            });
        }
        // 分割矩形、分割圆不必展示反转选项
        get hideInvertShape() {
            return [eLayoutType.SplitRect, eLayoutType.SplitCircle].includes(this.layoutData.layoutType);
        }
        setOption(type) {
            window["_view"].smartShapeOption(type, this.layoutData.layoutOptions[type]);
            this.sensors.track("editSmartShape", {
                Catalogues: "shortcutToolbar",
                content: type,
            });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "hFlip": "水平翻转",
        "vFlip": "垂直翻转",
        "odd": "翻转奇数列",
        "even": "翻转偶数列 ",
        "all": "所有行",
        "imgReverse": "图像反转",
        "swapDir": "图像横转"
    },
    "en": {
        "hFlip": "Horizontal Flip",
        "vFlip": "Vertical Flip",
        "odd": "Turn Around Odd Number",
        "even": "Turn Around Even Number",
        "all": "All Rows",
        "imgReverse": "Flip",
        "swapDir": "Landscape"
    },
    "fr": {
        "hFlip": "Flip horizontal",
        "vFlip": "Flip vertical",
        "odd": "Numéro impair",
        "even": "Numéro pair",
        "all": "Tout",
        "imgReverse": "Retourner",
        "swapDir": "Paysage"
    },
    "de": {
        "hFlip": "Horizontaler Flip",
        "vFlip": "Vertikaler Flip",
        "odd": "Ungerade Zahl umdrehen",
        "even": "Gerade Zahl umdrehen",
        "all": "Alles",
        "imgReverse": "Kippen",
        "swapDir": "Querformat"
    },
    "jp": {
        "hFlip": "水平回転",
        "vFlip": "垂直回転",
        "odd": "奇数",
        "even": "偶数",
        "all": "すべて",
        "imgReverse": "反転",
        "swapDir": "横向き"
    },
    "es": {
        "hFlip": "Vuelta horizontal",
        "vFlip": "Volteo vertical",
        "odd": "Girar el número impar",
        "even": "Girar el número par",
        "all": "Todas las filas",
        "imgReverse": "Voltear",
        "swapDir": "Horizontal"
    },
    "pt": {
        "hFlip": "Virar Horizontal",
        "vFlip": "Virar Vertical",
        "odd": "Voltar Número Ímpar",
        "even": "Voltar Número Par",
        "all": "Todas as Linhas",
        "imgReverse": "Inverter",
        "swapDir": "Paisagem"
    },
    "it": {
        "hFlip": "Capovolgi Orizzontalmente",
        "vFlip": "Capovolgi Verticalmente",
        "odd": "Ribalta Numeri Dispari",
        "even": "Ribalta Numeri Pari",
        "all": "Tutte le Righe",
        "imgReverse": "Ribalta",
        "swapDir": "Orizzontale"
    },
    "tw": {
        "hFlip": "水平翻轉",
        "vFlip": "垂直翻轉",
        "odd": "翻轉奇數列",
        "even": "翻轉偶數列",
        "all": "全部行",
        "imgReverse": "圖像反轉",
        "swapDir": "圖像橫轉"
    },
    "kr": {
        "hFlip": "수평 뒤집기",
        "vFlip": "세로 뒤집기",
        "odd": "홀수 반전",
        "even": "짝수 반전",
        "all": "모든 행",
        "imgReverse": "뒤집기",
        "swapDir": "가로"
    }
}
</i18n>
